import { x } from '@xstyled/styled-components';
import React from 'react';
import {
  Item,
  ItemDefinition,
  ItemValidationError,
  registry,
  RenderProps
} from '../Item';
import { BACKGROUND, COLOR } from '../itemIds';

interface Props {
  value: string;
}

export type ColorDefinition = ItemDefinition<typeof COLOR, Props>;

export class Color extends Item<typeof COLOR, Props> {
  protected validate(): void {
    if (this.parent?.type === BACKGROUND) return;
    throw new ItemValidationError(
      `An item of type [${COLOR}] can only be a child of an item of type [${BACKGROUND}]`
    );
  }

  protected render({ value }: RenderProps<Props>) {
    return <x.div backgroundColor={value} flex="1" />;
  }
}

registry[COLOR] = Color;
